export async function computeChecksum(file: File): Promise<string> {
  const arrayBuffer = await file.arrayBuffer();
  const hashBuffer = await globalThis.crypto.subtle.digest('SHA-256', arrayBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return btoa(String.fromCharCode(...hashArray));
}

export function getFileExtension(name: string) {
  const split = name.split('.');

  return split.length > 1
    ? split.pop()
    : null;
}

export function getFileNameParts(name: string) {
  const split = name.split('.');
  const extension = split.length > 1
    ? split.pop()
    : null;

  return [
    split.join('.'),
    extension,
  ];
}

export function getFileNameVersion(name: string, version: number) {
  const parts = getFileNameParts(name);

  const newBase = `${parts[0]} (${version})`;

  return [
    newBase,
    parts[1],
  ].filter(Boolean).join('.');

}